@if (apidata$ | async; as apidata) {
  @if (!isMobile) {
    <tabset type="pills">
      <tab heading='{{"common.warranty_eligibility_check" | cxTranslate }}'>
        <app-warranty-eligible-check [warranty]="apidata.warrantyTypeOperations"
          (selectedEligibilityResult)="getSelectedEligibilityResult($event)">
        </app-warranty-eligible-check>
      </tab>
      <tab heading='{{"common.warranty_terms" | cxTranslate }}'><app-warranty-terms> </app-warranty-terms></tab>
      <tab heading='{{"common.warranty_quick_coverage_guide" | cxTranslate }}'>
        <app-quick-coverage-guide [quickCoverageDocs]="apidata.quickCoverageDocs"> </app-quick-coverage-guide>
      </tab>
      <tab heading='{{"common.warranty_documents" | cxTranslate }}'>
        <app-warranty-documents [warrantyDocs]="apidata.warrantyDocs">
        </app-warranty-documents>
      </tab>
      <tab heading='{{"common.warranty_shipping_packaging" | cxTranslate }}'> <app-shipping-packaging></app-shipping-packaging></tab>
    </tabset>
  }
  @if (isMobile) {
    <accordion [closeOthers]="oneAtATime">
      <accordion-group [isOpen]="isFirstOpen" (isOpenChange)="log($event,1)">
        <button class="btn btn-link btn-block justify-content-between d-flex w-100  shadow-none" accordion-heading type="button">
          <div class="pull-left float-left">{{ 'common.warranty_eligibility_check' | cxTranslate }}</div>
          <div class=""><img [attr.src]="selectedIndex[1] ? '/icons/arrow_down.svg' : '/icons/arrow-right_light_blue.svg'" style="width: 20px;" alt=""></div>
        </button>
        <app-warranty-eligible-check [warranty]="apidata.warrantyTypeOperations"
          (selectedEligibilityResult)="getSelectedEligibilityResult($event)">
        </app-warranty-eligible-check>
      </accordion-group>
      <accordion-group (isOpenChange)="log($event,2)">
        <button class="btn btn-link btn-block justify-content-between d-flex w-100  shadow-none" accordion-heading type="button">
          <div class="pull-left float-left">{{ 'common.warranty_terms' | cxTranslate }}</div>
          <div class=""><img [attr.src]="selectedIndex[2] ? '/icons/arrow_down.svg' : '/icons/arrow-right_light_blue.svg'" style="width: 20px;" alt=""></div>
        </button>
        <app-warranty-terms></app-warranty-terms>
      </accordion-group>
      <accordion-group (isOpenChange)="log($event,3)">
        <button class="btn btn-link btn-block justify-content-between d-flex w-100  shadow-none" accordion-heading type="button">
          <div class="pull-left float-left">{{ 'common.warranty_quick_coverage_guide' | cxTranslate }}</div>
          <div class=""><img [attr.src]="selectedIndex[3] ? '/icons/arrow_down.svg' : '/icons/arrow-right_light_blue.svg'" style="width: 20px;" alt=""></div>
        </button>
        <app-quick-coverage-guide [quickCoverageDocs]="apidata.quickCoverageDocs"></app-quick-coverage-guide>
      </accordion-group>
      <accordion-group (isOpenChange)="log($event,4)">
        <button class="btn btn-link btn-block justify-content-between d-flex w-100  shadow-none" accordion-heading type="button">
          <div class="pull-left float-left">{{ 'common.warranty_documents' | cxTranslate }}</div>
          <div class=""><img [attr.src]="selectedIndex[4] ? '/icons/arrow_down.svg' : '/icons/arrow-right_light_blue.svg'" style="width: 20px;" alt=""></div>
        </button>
        <app-warranty-documents [warrantyDocs]="apidata.warrantyDocs"></app-warranty-documents>
      </accordion-group>
      <accordion-group (isOpenChange)="log($event,5)">
        <button class="btn btn-link btn-block justify-content-between d-flex w-100  shadow-none" accordion-heading type="button">
          <div class="pull-left float-left">{{ 'common.warranty_shipping_packaging' | cxTranslate }}</div>
          <div class=""><img [attr.src]="selectedIndex[5] ? '/icons/arrow_down.svg' : '/icons/arrow-right_light_blue.svg'" style="width: 20px;" alt=""></div>
        </button>
        <app-shipping-packaging></app-shipping-packaging>
      </accordion-group>
    </accordion>
  }
}

<div class="mt-3">
  @if (selectedWarranty === 'EligibilityCheckNoMatch') {
    <cx-page-slot position="EligibilityCheckNoMatch"></cx-page-slot>
  }

  @if (selectedWarranty === 'EligibilityCheckCovered') {
    <cx-page-slot position="EligibilityCheckCovered"></cx-page-slot>
  }

  @if (selectedWarranty === 'EligibilityCheckNotCovered') {
    <cx-page-slot position="EligibilityCheckNotCovered"></cx-page-slot>
  }
</div>
